import type { CSSProperties } from 'react';
import { neonFontSizeVar, neonFontWeightVar, neonLineHeightVar, neonVar } from '@/utils/neon-utils';

export const pageHeaderContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  width: '100%',
};

export const headerRowStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '12px',
  fontFamily: neonVar('font-family', 'Roboto, sans-serif'),
  fontSize: neonFontSizeVar('font-size-6', '24px'),
  lineHeight: neonLineHeightVar('line-height-6', '36px'),
  fontWeight: neonFontWeightVar('medium', 500),
};

export const titleStyle: CSSProperties = {
  margin: 0,
};

export const descriptionStyle: CSSProperties = {
  margin: 0,
  maxWidth: 700,
  fontFamily: neonVar('font-family', 'Roboto, sans-serif'),
  fontSize: neonFontSizeVar('font-size-2', '14px'),
  lineHeight: neonLineHeightVar('line-height-2', '20px'),
  fontWeight: 400,
};
